import axios from '@/settings/axios'
import {apiSettings} from "@/settings/api"

let base = '/user/';
export default {
    registration(request={}, version = apiSettings.user_ver) {
        return axios.post(base + version + '/registration', request);
    },
    sendCode(request={}, version = apiSettings.user_ver) {
        return axios.put(base + version + '/code', request);
    },
    sendPass(request={}, version = apiSettings.user_ver) {
        return axios.put(base + version + '/password', request);
    },
    get(version=apiSettings.user_ver){
        return axios.get(base + version + "/get");
    },
    login(request={},version = apiSettings.user_ver){
        return axios.post(base + version + "/login",request);
    },
    logout(version = apiSettings.user_ver){
        return axios.get(base + version + "/logout");
    },
    save(request={},version = apiSettings.user_ver) {
        return axios.put(base + version + '/save',request);
    },
    filesBind(type='',request, version = apiSettings.user_ver){
        return axios.put(base + version + '/bind/userfile/'+type,request);
    },
    filesUnBind(type='',version = apiSettings.user_ver){
        return axios.put(base + version + '/unbind/userfile/'+type);
    }
}